import logger from 'redux-logger'
import { isAction, type Middleware } from '@reduxjs/toolkit'
import {
  recordReduxAction,
  setReduxTelemetryStateGetter,
} from './telemetryContext'
import { setChatRequestContextProvider } from '@labrav/common'
import {
  getCurrentPageContext,
  getWindowLocation,
  setPageContextGetter,
} from './pageContextRegistry'
import { selectPageContext } from './selectPageContext'

let contextGettersRegistered = false

const telemetryReduxMiddleware: Middleware = storeApi => next => action => {
  if (!contextGettersRegistered) {
    setReduxTelemetryStateGetter(() => storeApi.getState())
    // Read the location at call time, not now: the getter outlives every
    // navigation, so capturing a location here would freeze it at boot.
    setPageContextGetter(() =>
      selectPageContext(storeApi.getState(), getWindowLocation())
    )
    // Point the chat package at the same registry, so every send carries the
    // page context without each call site passing it.
    setChatRequestContextProvider(getCurrentPageContext)
    contextGettersRegistered = true
  }

  if (isAction(action)) {
    recordReduxAction(action)
  }

  return next(action)
}

export const getMiddlewares = () => {
  if (['production', 'test'].includes(process.env.NODE_ENV || '')) {
    return [telemetryReduxMiddleware]
  }

  return [telemetryReduxMiddleware, logger]
}
